export enum CurrencyEnum {
  VND = 0,
  $ = 1,
}
